import { fabric } from 'fabric';
import DEFINE from '../define';
import head from '../../../assets/compass/head.svg';
import center from '../../../assets/compass/center.svg';
import left from '../../../assets/compass/left.svg';
import leftFlip from '../../../assets/compass/left_flip.svg';
import right from '../../../assets/compass/right.svg';
import rightFlip from '../../../assets/compass/right_flip.svg';
import horizontal_icon from '../../../assets/control/horizontal_icon.svg';
import rotator_icon from '../../../assets/control/rotator_icon.svg';
import delete_icon from '../../../assets/control/delete_icon.svg';
import flip_icon from '../../../assets/control/flip_icon.svg';
import ToolBase from '../basic';
import DefineControl from '../controls';

export default class Compass extends ToolBase {

    name = DEFINE.TOOLS.COMPASS;

    originPosition = new fabric.Point(600, 550);
    centerOffset = { x: 0, y: -150 };
    baseScale = 0.25 * 1.2;
    baseControlScale = 0.1 * 1.2;
    scale = this.baseScale;
    controlScale = this.baseControlScale;

    setting = null;
    isDown = false;
    isFlip = false;
    arc = null;
    targetTag = "";
    /**
     * is compass show on screen
     * @type {Boolean}
     * @memberof Compass
     */
    show = false;

    // 圓規
    head = null;
    center = null;
    left = null;
    right = null;
    rotator = null;
    horizontal = null;
    delete = null;
    flip = null;

    // arc
    startAngle = 0;
    endAngle = 0;
    maxStartAngle = 0;
    maxEndAngle = 0;

    legHeight = 769;

    originPointer = null;
    originInformation = {
        head: {
            x: 0,
            y: 0,
        },
        center: {
            x: 0,
            y: 0,
        },
        left: {
            x: 0,
            y: 0,
        },
        right: {
            x: 0,
            y: 0,
        }
    }

    lastPointer = [];
    lastAngle = [];

    constructor(parent) {
        super(parent);
    }

    create() {
        super.create();

        const self = this;

        this.isFlip = false;
        this.originPosition = {
            x: fabric.util.invertTransform(this.canvas.viewportTransform)[4] + ((this.canvas.width / 2 - this.centerOffset.x) * fabric.util.invertTransform(this.canvas.viewportTransform)[0]),
            y: fabric.util.invertTransform(this.canvas.viewportTransform)[5] + ((this.canvas.height / 2 - this.centerOffset.y) * fabric.util.invertTransform(this.canvas.viewportTransform)[3])
        }

        // 限制只能生成一個圓規
        this.canvas.getObjects().forEach(object => {
            if (object && (object.tag || "").includes(DEFINE.TAG.COMPASS)) {
                self.canvas.remove(object);
            }
        })

        fabric.loadSVGFromURL(left, (objects, options) => {
            self.left = new fabric.util.groupSVGElements(objects, options);

            self.left.set({
                tag: DEFINE.TAG.COMPASS_LEFT + new Date().getTime(),
                toolType: self.name,
                selectionActive: true,
                left: self.originPosition.x,
                top: self.originPosition.y,
                angle: 0,
                scaleX: self.scale,
                scaleY: self.scale,
                selectable: false,
                perPixelTargetFind: true,
                originX: "right",
                originY: "bottom"
            });

            self.canvas.add(self.left).renderAll();
        });

        fabric.loadSVGFromURL(right, (objects, options) => {
            self.right = new fabric.util.groupSVGElements(objects, options);

            self.right.set({
                tag: DEFINE.TAG.COMPASS_RIGHT + new Date().getTime(),
                toolType: self.name,
                selectionActive: true,
                left: self.originPosition.x,
                top: self.originPosition.y,
                angle: 0,
                scaleX: self.scale,
                scaleY: self.scale,
                selectable: false,
                perPixelTargetFind: true,
                originX: "left",
                originY: "bottom"
            });

            fabric.loadSVGFromURL(horizontal_icon, (objects, options) => {
                self.horizontal = new fabric.util.groupSVGElements(objects, options);

                self.horizontal.set({
                    tag: DEFINE.TAG.COMPASS_HORIZONTAL + new Date().getTime(),
                    toolType: self.name,
                    scaleX: self.controlScale,
                    scaleY: self.controlScale,
                    selectable: false,
                    left: self.right.left,
                    top: self.right.top,
                    perPixelTargetFind: true,
                    originX: "center",
                    originY: "center",
                    visible: false
                });

                self.canvas.add(self.horizontal).renderAll();
            });

            self.canvas.add(self.right).renderAll();
        });

        fabric.loadSVGFromURL(head, (objects, options) => {
            self.head = new fabric.util.groupSVGElements(objects, options);

            self.head.set({
                tag: DEFINE.TAG.COMPASS_HEAD + new Date().getTime(),
                toolType: self.name,
                selectionActive: true,
                left: self.originPosition.x,
                top: self.originPosition.y - (self.legHeight * self.scale),
                angle: 0,
                scaleX: self.scale,
                scaleY: self.scale,
                selectable: false,
                perPixelTargetFind: true,
                originX: "center",
                originY: "bottom",
                controls: {
                    mtr: this.getTouchRotateControl({
                        x: 0.5,
                        y: 0,
                        offsetX: 25,
                        offsetY: -10,
                    })
                }
            });

            self.canvas.add(self.head).renderAll();

            let flipPoint = this.getEndPointByTrigonometric(0, {
                x: (this.head.aCoords.tr.x + this.head.aCoords.br.x) / 2,
                y: (this.head.aCoords.tr.y + this.head.aCoords.br.y) / 2
            }, 25 * 10 * this.controlScale)
            fabric.loadSVGFromURL(flip_icon, (dObjects, dOptions) => {
                self.flip = new fabric.util.groupSVGElements(dObjects, dOptions);

                self.flip.set({
                    tag: DEFINE.TAG.COMPASS_FLIP + new Date().getTime(),
                    toolType: self.name,
                    selectionActive: true,
                    left: flipPoint.x,
                    top: flipPoint.y,
                    angle: 0,
                    scaleX: this.controlScale,
                    scaleY: this.controlScale,
                    selectable: false,
                    perPixelTargetFind: true,
                    originX: "center",
                    originY: "center",
                });

                self.canvas.add(self.flip).renderAll();
            });

            let deletePoint = this.getEndPointByTrigonometric(0, {
                x: (this.head.aCoords.tr.x + this.head.aCoords.br.x) / 2,
                y: (this.head.aCoords.tr.y + this.head.aCoords.br.y) / 2
            }, 60 * 10 * this.controlScale)
            fabric.loadSVGFromURL(delete_icon, (dObjects, dOptions) => {
                self.delete = new fabric.util.groupSVGElements(dObjects, dOptions);

                self.delete.set({
                    tag: DEFINE.TAG.COMPASS_DELETE + new Date().getTime(),
                    toolType: self.name,
                    selectionActive: true,
                    left: deletePoint.x,
                    top: deletePoint.y,
                    angle: 0,
                    scaleX: this.controlScale,
                    scaleY: this.controlScale,
                    selectable: false,
                    perPixelTargetFind: true,
                    originX: "center",
                    originY: "center",
                });

                self.canvas.add(self.delete).renderAll();
            });

            fabric.loadSVGFromURL(rotator_icon, (objects, options) => {
                self.rotator = new fabric.util.groupSVGElements(objects, options);

                self.rotator.set({
                    tag: DEFINE.TAG.COMPASS_ROTATOR + new Date().getTime(),
                    toolType: self.name,
                    scaleX: self.controlScale,
                    scaleY: self.controlScale,
                    selectable: false,
                    left: (self.head.aCoords.tl.x + self.head.aCoords.tr.x) / 2,
                    top: (self.head.aCoords.tl.y + self.head.aCoords.tr.y) / 2,
                    perPixelTargetFind: true,
                    originX: "center",
                    originY: "center",
                    visible: false
                });

                self.canvas.add(self.rotator).renderAll();
            });
        });

        fabric.loadSVGFromURL(center, (objects, options) => {
            self.center = new fabric.util.groupSVGElements(objects, options);

            self.center.set({
                tag: DEFINE.TAG.COMPASS_CENTER + new Date().getTime(),
                toolType: self.name,
                selectionActive: true,
                left: self.originPosition.x,
                top: self.originPosition.y - (self.legHeight * self.scale),
                angle: 0,
                scaleX: self.scale,
                scaleY: self.scale,
                selectable: false,
                perPixelTargetFind: true,
                originX: "center",
                originY: "center"
            });

            self.canvas.add(self.center).renderAll();
        });



        this.show = true;
    }

    recover(object) {
        let tag = object.tag;

        if (tag.includes(DEFINE.TAG.COMPASS_LEFT)) {
            this.left = object;

            this.isFlip = this.left.fixedFlip;
        } else if (tag.includes(DEFINE.TAG.COMPASS_RIGHT)) {
            this.right = object;
        } else if (tag.includes(DEFINE.TAG.COMPASS_CENTER)) {
            this.center = object;
        } else if (tag.includes(DEFINE.TAG.COMPASS_HEAD)) {
            this.head = object;
        } else if (tag.includes(DEFINE.TAG.COMPASS_DELETE)) {
            this.delete = object;
        } else if (tag.includes(DEFINE.TAG.COMPASS_FLIP)) {
            this.flip = object;
        } else if (tag.includes(DEFINE.TAG.COMPASS_ROTATOR)) {
            this.rotator = object;
        } else if (tag.includes(DEFINE.TAG.COMPASS_HORIZONTAL)) {
            this.horizontal = object;
        } else if (tag.includes(DEFINE.TAG.ARC)) {
            DefineControl.Instance.setDefaultControl(object, this);
        }

        this.show = true;
    }

    mouseDownBefore(o) {
        /** 點擊之前先把所有元件都設定為不可選取 */
        if (this.head) this.head.set("selectable", false); 
        if (this.center) this.center.set("selectable", false); 
        if (this.left) this.left.set("selectable", false); 
        if (this.right) this.right.set("selectable", false); 
        if (this.rotator) this.rotator.set("selectable", false); 
        if (this.horizontal) this.horizontal.set("selectable", false); 
        if (this.delete) this.delete.set("selectable", false); 
        if (this.flip) this.flip.set("selectable", false); 
    }

    mouseUp(o) {
        if (this.arc) {
            this.parent.addHistory();
        }

        if (o.target && o.target.tag.includes(DEFINE.TAG.COMPASS_DELETE)) {
            this.canvas.remove(this.left, this.right, this.center, this.head, this.delete, this.flip).requestRenderAll();
            this.show = false;
        }

        if (o.target && o.target.tag.includes(DEFINE.TAG.COMPASS_FLIP)) {
            this.isFlip = !this.isFlip;

            let leftSvg = (this.isFlip) ? leftFlip : left;
            let rightSvg = (this.isFlip) ? rightFlip : right;

            let leftSetting = {
                tag: this.left.tag,
                x: this.left.left,
                y: this.left.top,
                originX: this.left.originX,
                originY: this.left.originY,
                angle: this.left.angle,
            };
            let rightSetting = {
                tag: this.right.tag,
                x: this.right.left,
                y: this.right.top,
                originX: this.right.originX,
                originY: this.right.originY,
                angle: this.right.angle,
            };

            fabric.loadSVGFromURL(leftSvg, (objects, options) => {
                let newLeft = new fabric.util.groupSVGElements(objects, options);

                newLeft.set({
                    tag: this.left.tag,
                    toolType: this.left.toolType,
                    selectionActive: this.left.selectionActive,
                    left: rightSetting.x,
                    top: rightSetting.y,
                    angle: rightSetting.angle,
                    scaleX: this.left.scaleX,
                    scaleY: this.left.scaleY,
                    selectable: this.left.selectable,
                    perPixelTargetFind: this.left.perPixelTargetFind,
                    originX: rightSetting.originX,
                    originY: rightSetting.originY,
                    fixedFlip: this.isFlip,
                })

                this.canvas.remove(this.left).add(newLeft).requestRenderAll();
                this.left = newLeft;
            });

            fabric.loadSVGFromURL(rightSvg, (objects, options) => {
                let newRight = new fabric.util.groupSVGElements(objects, options);

                newRight.set({
                    tag: this.right.tag,
                    toolType: this.right.toolType,
                    selectionActive: this.right.selectionActive,
                    left: leftSetting.x,
                    top: leftSetting.y,
                    angle: leftSetting.angle,
                    scaleX: this.right.scaleX,
                    scaleY: this.right.scaleY,
                    selectable: this.right.selectable,
                    perPixelTargetFind: this.right.perPixelTargetFind,
                    originX: leftSetting.originX,
                    originY: leftSetting.originY,
                })

                this.canvas.remove(this.right).add(newRight).requestRenderAll();
                this.right = newRight;
            });

            this.left.setCoords()
            this.right.setCoords()
        }

        this.arc = null;
        this.isDown = false;
        this.targetTag = "";
        this.startAngle = 0;
        this.endAngle = 0;

        this.parent.changeTool(null);

        this.canvas.renderAll();
    }

    mouseDown(o) {
        if (o.target) {
            if (o.target.tag) {
                if (o.target.tag.includes(DEFINE.TAG.COMPASS)) {
                    let viewportTransform = this.canvas.viewportTransform;
                    this.setting = this.parent.getDrawSetting(DEFINE.DRAW_TYPE.LINE_SEGMENT);
                    this.isDown = true;
                    this.arc = null;

                    // 紀錄初始資料
                    this.originInformation.head.x = this.head.left;
                    this.originInformation.head.y = this.head.top;
                    this.originInformation.center.x = this.center.left;
                    this.originInformation.center.y = this.center.top;
                    this.originInformation.left.x = this.left.left;
                    this.originInformation.left.y = this.left.top;
                    this.originInformation.right.x = this.right.left;
                    this.originInformation.right.y = this.right.top;

                    this.targetTag = o.target.tag;
                    this.originPointer = {
                        x: (o.pointer.x - viewportTransform[4]) / viewportTransform[0],
                        y: (o.pointer.y - viewportTransform[5]) / viewportTransform[3]
                    };
                    this.lastPointer = [];
                    this.lastAngle = [];

                    // 這邊要計算點擊的偏移角度
                    let pointAngle = Math.atan2(this.originPointer.y - this.originInformation.left.y, this.originPointer.x - this.originInformation.left.x) * (180 / Math.PI);
                    let leftAngle = Math.atan2(this.left.aCoords.tr.y - this.originInformation.left.y, this.left.aCoords.tr.x - this.originInformation.left.x) * (180 / Math.PI);
                    this.offsetAngle = leftAngle - pointAngle;

                    this.rotator.set("visible", false);
                    this.horizontal.set("visible", false);
                }
            }
        }
    }

    mouseMove(o) {
        if (this.isDown) {
            if (this.targetTag.includes(DEFINE.TAG.COMPASS)) {
                let viewportTransform = this.canvas.viewportTransform;
                let pointer = {
                    x: (o.pointer.x - viewportTransform[4]) / viewportTransform[0],
                    y: (o.pointer.y - viewportTransform[5]) / viewportTransform[3]
                };
                let angle = Math.atan2(pointer.y - this.originInformation.left.y, pointer.x - this.originInformation.left.x) * (180 / Math.PI);
                let newAngle = 0;

                if (this.targetTag.includes(DEFINE.TAG.COMPASS_HEAD)) {
                    if (this.isFlip) {
                        let a = this.left.height * this.scale;
                        let b = this.right.height * this.scale;
                        let c = Math.sqrt(Math.pow((this.right.aCoords.br.x - this.left.aCoords.bl.x), 2) + Math.pow((this.right.aCoords.br.y - this.left.aCoords.bl.y), 2));

                        if (c < 1) c = 1;

                        let cosA = Math.acos((a * a + b * b - c * c) / (2 * a * b)) / (Math.PI / 180);
                        let cosB = Math.acos((b * b + c * c - a * a) / (2 * b * c)) / (Math.PI / 180);
                        let cosC = Math.acos((c * c + a * a - b * b) / (2 * c * a)) / (Math.PI / 180);

                        newAngle = (360 + (angle + this.offsetAngle) + (cosB - Math.abs(cosA - 180))) % 360;
                        this.lastAngle.push(newAngle);

                        let rotatePoint = {
                            x: this.left.aCoords.bl.x + c * Math.cos(newAngle * Math.PI / 180),
                            y: this.left.aCoords.bl.y + c * Math.sin(newAngle * Math.PI / 180)
                        };

                        this.left.set({
                            angle: -(270 - cosC) + newAngle
                        })
                        this.left.setCoords();
                        this.canvas.renderAll();

                        this.right.set({
                            left: rotatePoint.x,
                            top: rotatePoint.y,
                            angle: -(cosB - 270) + newAngle
                        })
                        this.right.setCoords();
                        this.canvas.renderAll();

                        this.center.set({
                            left: this.left.aCoords.tl.x,
                            top: this.left.aCoords.tl.y,
                            angle: newAngle - 180
                        })
                        this.center.setCoords();
                        this.canvas.renderAll();

                        this.head.set({
                            left: this.left.aCoords.tl.x,
                            top: this.left.aCoords.tl.y,
                            angle: newAngle - 180
                        })
                        this.head.setCoords();
                        this.canvas.renderAll();

                        if (this.endAngle - this.startAngle < 360) {
                            if (this.arc) {
                                let calcStartDistance = (this.startAngle > 360) ? newAngle - 360 : this.startAngle - newAngle;
                                let calcEndDistance = (this.endAngle < 0) ? 360 + newAngle : newAngle - this.endAngle;

                                let absStartDistance = Math.abs(calcStartDistance);
                                let absEndDistance = Math.abs(calcEndDistance);

                                let over180 = 0;

                                let centerCircle = this.parent.proxy.getWidth(DEFINE.OPERATE.PEN);

                                if (this.startAngle > newAngle || newAngle > this.endAngle) {
                                    if (absStartDistance + absEndDistance > 360) {
                                        let d = Math.abs(this.startAngle - this.endAngle);

                                        if (d > 180) {
                                            over180 = 1;
                                        }

                                        if (calcStartDistance < calcEndDistance) {
                                            this.startAngle = newAngle - 360;

                                            if (this.startAngle > this.maxStartAngle) {
                                                this.startAngle = this.maxStartAngle;
                                            } else {
                                                this.maxStartAngle = this.startAngle;
                                            }
                                        } else {
                                            this.endAngle = 360 + newAngle;

                                            if (this.endAngle < this.maxEndAngle) {
                                                this.endAngle = this.maxEndAngle;
                                            } else {
                                                this.maxEndAngle = this.endAngle;
                                            }
                                        }
                                    } else {
                                        if (absStartDistance > 180 || absEndDistance > 180) {
                                            over180 = 1;
                                        }

                                        if (calcStartDistance > calcEndDistance) {
                                            this.startAngle = newAngle;
                                        } else {
                                            this.endAngle = newAngle;
                                        }
                                    }

                                    let angleD = this.endAngle - this.startAngle;

                                    if (over180 && angleD > 355) {
                                        this.startAngle = 0;
                                        this.endAngle = 359.999999999;
                                        this.maxStartAngle = this.startAngle;
                                        this.maxEndAngle = this.endAngle;
                                    } else if (over180 && angleD > 350 && this.lastAngle.length > 2) {
                                        let a = Math.abs(this.startAngle - this.lastAngle[this.lastAngle.length - 2]);
                                        let b = Math.abs(this.endAngle - this.lastAngle[this.lastAngle.length - 1]);
                                        let c = Math.abs(this.startAngle - this.lastAngle[this.lastAngle.length - 1]);
                                        let d = Math.abs(this.endAngle - this.lastAngle[this.lastAngle.length - 2]);

                                        let disL = 20;

                                        if (
                                            (a < disL && b < disL) || (a < disL && c < disL) || (a < disL && d < disL) ||
                                            (b < disL && c < disL) || (b < disL && d < disL) ||
                                            (c < disL && d < disL)
                                        ) {
                                            if (Math.abs(this.lastAngle[this.lastAngle.length - 2] - this.lastAngle[this.lastAngle.length - 1]) > 2) {
                                                this.startAngle = 0;
                                                this.endAngle = 359.999999999;
                                                this.maxStartAngle = this.startAngle;
                                                this.maxEndAngle = this.endAngle;
                                            }
                                        }
                                    } else if (over180 && angleD > 270 && this.lastAngle.length > 2) {
                                        let a = Math.abs(this.startAngle - this.lastAngle[this.lastAngle.length - 2]);
                                        let b = Math.abs(this.endAngle - this.lastAngle[this.lastAngle.length - 1]);
                                        let c = Math.abs(this.startAngle - this.lastAngle[this.lastAngle.length - 1]);
                                        let d = Math.abs(this.endAngle - this.lastAngle[this.lastAngle.length - 2]);

                                        let disL = 30;

                                        if (
                                            (a < disL && b < disL) || (a < disL && c < disL) || (a < disL && d < disL) ||
                                            (b < disL && c < disL) || (b < disL && d < disL) ||
                                            (c < disL && d < disL)
                                        ) {
                                            if (Math.abs(this.lastAngle[this.lastAngle.length - 2] - this.lastAngle[this.lastAngle.length - 1]) > 10) {
                                                this.startAngle = 0;
                                                this.endAngle = 359.999999999;
                                                this.maxStartAngle = this.startAngle;
                                                this.maxEndAngle = this.endAngle;
                                            }
                                        }
                                    }

                                    let aPoint = {
                                        x: this.left.aCoords.bl.x + (c) * Math.cos(this.startAngle * Math.PI / 180),
                                        y: this.left.aCoords.bl.y + (c) * Math.sin(this.startAngle * Math.PI / 180)
                                    };
                                    let bPoint = {
                                        x: this.left.aCoords.bl.x + (c) * Math.cos(this.endAngle * Math.PI / 180),
                                        y: this.left.aCoords.bl.y + (c) * Math.sin(this.endAngle * Math.PI / 180)
                                    };

                                    let path = `
                                        M ${this.originInformation.left.x + centerCircle} ${this.originInformation.left.y} 
                                        A ${centerCircle} ${centerCircle} 0 1 1 ${this.originInformation.left.x - centerCircle} ${this.originInformation.left.y} 
                                        Z
                                        M ${this.originInformation.left.x - centerCircle} ${this.originInformation.left.y} 
                                        A ${centerCircle} ${centerCircle} 0 1 1 ${this.originInformation.left.x + centerCircle} ${this.originInformation.left.y}
                                        Z
                                        M ${aPoint.x} ${aPoint.y} 
                                        A ${c} ${c} 0 ${over180} 1 ${bPoint.x} ${bPoint.y}
                                    `;

                                    let newArc = new fabric.Path(path, {})

                                    this.arc.set({
                                        width: newArc.width,
                                        height: newArc.height,
                                        top: newArc.top,
                                        left: newArc.left,
                                        path: newArc.path,
                                        pathOffset: newArc.pathOffset
                                    })

                                    DefineControl.Instance.setDefaultControl(this.arc, this);

                                    this.arc.setCoords();
                                }
                            } else {
                                let centerCircle = this.parent.proxy.getWidth(DEFINE.OPERATE.PEN);
                                let path = `
                                    M ${this.originInformation.left.x} ${this.originInformation.left.y} 
                                    A 1 1 0 1 1 ${this.originInformation.left.x + centerCircle} ${this.originInformation.left.y} 
                                    A 1 1 0 1 1 ${this.originInformation.left.x} ${this.originInformation.left.y}
                                    M ${rotatePoint.x} ${rotatePoint.y} 
                                    A ${c} ${c} 0 0 1 ${rotatePoint.x} ${rotatePoint.y}
                                `;

                                this.startAngle = newAngle + 0.1;
                                this.endAngle = newAngle;
                                this.maxStartAngle = newAngle + 0.1;
                                this.maxEndAngle = newAngle;

                                this.arc = new fabric.Path(path, {
                                    stroke: this.parent.proxy.getColor(DEFINE.OPERATE.PEN),
                                    strokeWidth: this.parent.proxy.getWidth(DEFINE.OPERATE.PEN),
                                    fill: "",
                                    perPixelTargetFind: true,
                                    strokeUniform: true,
                                    // TODO: 這邊因為圓規的toolType會導致畫出來的弧形無法刪除掉，所以把toolType設定為Circle
                                    toolType: DEFINE.TOOLS.CIRCLE,
                                    tag: DEFINE.TAG.ARC + new Date().getTime(),
                                })

                                this.canvas.add(this.arc);
                            }
                        }
                    } else {
                        let a = this.left.height * this.scale;
                        let b = this.right.height * this.scale;
                        let c = Math.sqrt(Math.pow((this.left.aCoords.br.x - this.right.aCoords.bl.x), 2) + Math.pow((this.left.aCoords.br.y - this.right.aCoords.bl.y), 2));

                        if (c < 1) c = 1;

                        let cosA = Math.acos((a * a + b * b - c * c) / (2 * a * b)) / (Math.PI / 180);
                        let cosB = Math.acos((b * b + c * c - a * a) / (2 * b * c)) / (Math.PI / 180);
                        let cosC = Math.acos((c * c + a * a - b * b) / (2 * c * a)) / (Math.PI / 180);

                        newAngle = (360 + (angle + this.offsetAngle) - (cosB - Math.abs(cosA - 180))) % 360;
                        this.lastAngle.push(newAngle);

                        let rotatePoint = {
                            x: this.left.aCoords.br.x + c * Math.cos(newAngle * Math.PI / 180),
                            y: this.left.aCoords.br.y + c * Math.sin(newAngle * Math.PI / 180)
                        };

                        this.left.set({
                            angle: -(cosB + 270) + newAngle
                        })
                        this.left.setCoords();

                        this.right.set({
                            left: rotatePoint.x,
                            top: rotatePoint.y,
                            angle: (cosC + 270) + newAngle
                        })
                        this.right.setCoords();

                        this.center.set({
                            left: this.left.aCoords.tr.x,
                            top: this.left.aCoords.tr.y,
                            angle: newAngle
                        })
                        this.center.setCoords();

                        this.head.set({
                            left: this.left.aCoords.tr.x,
                            top: this.left.aCoords.tr.y,
                            angle: newAngle
                        })
                        this.head.setCoords();

                        if (this.endAngle - this.startAngle < 360) {
                            if (this.arc) {
                                let calcStartDistance = (this.startAngle > 360) ? newAngle - 360 : this.startAngle - newAngle;
                                let calcEndDistance = (this.endAngle < 0) ? 360 + newAngle : newAngle - this.endAngle;

                                let absStartDistance = Math.abs(calcStartDistance);
                                let absEndDistance = Math.abs(calcEndDistance);

                                let over180 = 0;

                                let centerCircle = this.parent.proxy.getWidth(DEFINE.OPERATE.PEN);

                                if (this.startAngle > newAngle || newAngle > this.endAngle) {
                                    if (absStartDistance + absEndDistance > 360) {
                                        let d = Math.abs(this.startAngle - this.endAngle);

                                        if (d > 180) {
                                            over180 = 1;
                                        }

                                        if (calcStartDistance < calcEndDistance) {
                                            this.startAngle = newAngle - 360;

                                            if (this.startAngle > this.maxStartAngle) {
                                                this.startAngle = this.maxStartAngle;
                                            } else {
                                                this.maxStartAngle = this.startAngle;
                                            }
                                        } else {
                                            this.endAngle = 360 + newAngle;

                                            if (this.endAngle < this.maxEndAngle) {
                                                this.endAngle = this.maxEndAngle;
                                            } else {
                                                this.maxEndAngle = this.endAngle;
                                            }
                                        }
                                    } else {
                                        if (absStartDistance > 180 || absEndDistance > 180) {
                                            over180 = 1;
                                        }

                                        if (calcStartDistance > calcEndDistance) {
                                            this.startAngle = newAngle;
                                        } else {
                                            this.endAngle = newAngle;
                                        }
                                    }

                                    let angleD = this.endAngle - this.startAngle;

                                    if (over180 && angleD > 355) {
                                        this.startAngle = 0;
                                        this.endAngle = 359.999999999;
                                        this.maxStartAngle = this.startAngle;
                                        this.maxEndAngle = this.endAngle;
                                    } else if (over180 && angleD > 350 && this.lastAngle.length > 2) {
                                        let a = Math.abs(this.startAngle - this.lastAngle[this.lastAngle.length - 2]);
                                        let b = Math.abs(this.endAngle - this.lastAngle[this.lastAngle.length - 1]);
                                        let c = Math.abs(this.startAngle - this.lastAngle[this.lastAngle.length - 1]);
                                        let d = Math.abs(this.endAngle - this.lastAngle[this.lastAngle.length - 2]);

                                        let disL = 20;

                                        if (
                                            (a < disL && b < disL) || (a < disL && c < disL) || (a < disL && d < disL) ||
                                            (b < disL && c < disL) || (b < disL && d < disL) ||
                                            (c < disL && d < disL)
                                        ) {
                                            if (Math.abs(this.lastAngle[this.lastAngle.length - 2] - this.lastAngle[this.lastAngle.length - 1]) > 2) {
                                                this.startAngle = 0;
                                                this.endAngle = 359.999999999;
                                                this.maxStartAngle = this.startAngle;
                                                this.maxEndAngle = this.endAngle;
                                            }
                                        }
                                    } else if (over180 && angleD > 270 && this.lastAngle.length > 2) {
                                        let a = Math.abs(this.startAngle - this.lastAngle[this.lastAngle.length - 2]);
                                        let b = Math.abs(this.endAngle - this.lastAngle[this.lastAngle.length - 1]);
                                        let c = Math.abs(this.startAngle - this.lastAngle[this.lastAngle.length - 1]);
                                        let d = Math.abs(this.endAngle - this.lastAngle[this.lastAngle.length - 2]);

                                        let disL = 30;

                                        if (
                                            (a < disL && b < disL) || (a < disL && c < disL) || (a < disL && d < disL) ||
                                            (b < disL && c < disL) || (b < disL && d < disL) ||
                                            (c < disL && d < disL)
                                        ) {
                                            if (Math.abs(this.lastAngle[this.lastAngle.length - 2] - this.lastAngle[this.lastAngle.length - 1]) > 10) {
                                                this.startAngle = 0;
                                                this.endAngle = 359.999999999;
                                                this.maxStartAngle = this.startAngle;
                                                this.maxEndAngle = this.endAngle;
                                            }
                                        }
                                    }

                                    let aPoint = {
                                        x: this.left.aCoords.br.x + (c) * Math.cos(this.startAngle * Math.PI / 180),
                                        y: this.left.aCoords.br.y + (c) * Math.sin(this.startAngle * Math.PI / 180)
                                    };
                                    let bPoint = {
                                        x: this.left.aCoords.br.x + (c) * Math.cos(this.endAngle * Math.PI / 180),
                                        y: this.left.aCoords.br.y + (c) * Math.sin(this.endAngle * Math.PI / 180)
                                    };

                                    let path = `
                                        M ${this.originInformation.left.x + centerCircle} ${this.originInformation.left.y} 
                                        A ${centerCircle} ${centerCircle} 0 1 1 ${this.originInformation.left.x - centerCircle} ${this.originInformation.left.y} 
                                        Z
                                        M ${this.originInformation.left.x - centerCircle} ${this.originInformation.left.y} 
                                        A ${centerCircle} ${centerCircle} 0 1 1 ${this.originInformation.left.x + centerCircle} ${this.originInformation.left.y}
                                        Z
                                        M ${aPoint.x} ${aPoint.y} 
                                        A ${c} ${c} 0 ${over180} 1 ${bPoint.x} ${bPoint.y}
                                    `;

                                    let newArc = new fabric.Path(path, {})

                                    this.arc.set({
                                        width: newArc.width,
                                        height: newArc.height,
                                        top: newArc.top,
                                        left: newArc.left,
                                        path: newArc.path,
                                        pathOffset: newArc.pathOffset
                                    })

                                    DefineControl.Instance.setDefaultControl(this.arc, this);

                                    this.arc.setCoords();
                                }
                            } else {
                                let centerCircle = this.parent.proxy.getWidth(DEFINE.OPERATE.PEN);
                                let path = `
                                    M ${this.originInformation.left.x} ${this.originInformation.left.y} 
                                    A 1 1 0 1 1 ${this.originInformation.left.x + centerCircle} ${this.originInformation.left.y} 
                                    A 1 1 0 1 1 ${this.originInformation.left.x} ${this.originInformation.left.y}
                                    M ${rotatePoint.x} ${rotatePoint.y} 
                                    A ${c} ${c} 0 0 1 ${rotatePoint.x} ${rotatePoint.y}
                                `;

                                this.startAngle = newAngle + 0.1;
                                this.endAngle = newAngle;
                                this.maxStartAngle = newAngle + 0.1;
                                this.maxEndAngle = newAngle;

                                this.arc = new fabric.Path(path, {
                                    stroke: this.parent.proxy.getColor(DEFINE.OPERATE.PEN),
                                    strokeWidth: this.parent.proxy.getWidth(DEFINE.OPERATE.PEN),
                                    fill: "",
                                    perPixelTargetFind: true,
                                    strokeUniform: true,
                                    // TODO: 這邊因為圓規的toolType會導致畫出來的弧形無法刪除掉，所以把toolType設定為Circle
                                    toolType: DEFINE.TOOLS.CIRCLE,
                                    tag: DEFINE.TAG.ARC + new Date().getTime(),
                                })

                                this.canvas.add(this.arc);
                            }
                        }
                    }
                } else if (this.targetTag.includes(DEFINE.TAG.COMPASS_CENTER) || this.targetTag.includes(DEFINE.TAG.COMPASS_LEFT)) {
                    let offset = new fabric.Point(pointer.x - this.originPointer.x, pointer.y - this.originPointer.y);

                    this.head.set({
                        left: this.originInformation.center.x + offset.x,
                        top: this.originInformation.center.y + offset.y,
                    })
                    this.head.setCoords();

                    this.center.set({
                        left: this.originInformation.center.x + offset.x,
                        top: this.originInformation.center.y + offset.y,
                    })
                    this.center.setCoords();

                    this.left.set({
                        left: this.originInformation.left.x + offset.x,
                        top: this.originInformation.left.y + offset.y,
                    })
                    this.left.setCoords();

                    this.right.set({
                        left: this.originInformation.right.x + offset.x,
                        top: this.originInformation.right.y + offset.y,
                    })
                    this.right.setCoords();
                } else if (this.targetTag.includes(DEFINE.TAG.COMPASS_RIGHT)) {
                    let a = this.left.height * this.scale;
                    let b = this.right.height * this.scale;
                    let c = Math.sqrt(Math.pow((pointer.x - this.originInformation.left.x), 2) + Math.pow((pointer.y - this.originInformation.left.y), 2));
                    let newPointer = { x: pointer.x, y: pointer.y };

                    if (c >= a + b) {
                        c = (a + b) * 0.999999999999;

                        let slope = (pointer.y - this.originInformation.left.y) / (pointer.x - this.originInformation.left.x);
                        let reverse = 1;

                        if (pointer.x < this.originInformation.left.x) {
                            reverse *= -1;
                        }

                        newPointer = {
                            x: this.originInformation.left.x + (c / Math.sqrt(Math.pow(slope, 2) + 1)) * reverse,
                            y: this.originInformation.left.y + ((c / Math.sqrt(Math.pow(slope, 2) + 1)) * slope) * reverse
                        }
                    }

                    let cosA = Math.acos((a * a + b * b - c * c) / (2 * a * b)) / (Math.PI / 180);
                    let cosB = Math.acos((b * b + c * c - a * a) / (2 * b * c)) / (Math.PI / 180);
                    let cosC = Math.acos((c * c + a * a - b * b) / (2 * c * a)) / (Math.PI / 180);

                    if (cosA || cosB || cosC) {
                        if (this.isFlip) {
                            this.left.set({
                                angle: cosB - 270 + angle
                            })
                            this.left.setCoords();

                            this.right.set({
                                left: newPointer.x,
                                top: newPointer.y,
                                angle: angle + (cosA / 2) + 180
                            })
                            this.right.setCoords();

                            this.center.set({
                                left: this.left.aCoords.tl.x,
                                top: this.left.aCoords.tl.y,
                                angle: angle - 180
                            })
                            this.center.setCoords();

                            this.head.set({
                                left: this.left.aCoords.tl.x,
                                top: this.left.aCoords.tl.y,
                                angle: angle - 180
                            })
                            this.head.setCoords();
                        } else {
                            this.left.set({
                                angle: -(cosB + 270) + angle
                            })
                            this.left.setCoords();

                            this.right.set({
                                left: newPointer.x,
                                top: newPointer.y,
                                angle: (cosC + 270) + angle
                            })
                            this.right.setCoords();

                            this.center.set({
                                left: this.left.aCoords.tr.x,
                                top: this.left.aCoords.tr.y,
                                angle: angle
                            })
                            this.center.setCoords();

                            this.head.set({
                                left: this.left.aCoords.tr.x,
                                top: this.left.aCoords.tr.y,
                                angle: angle
                            })
                            this.head.setCoords();
                        }
                    }
                }

                let flipPoint = this.getEndPointByTrigonometric(this.head.angle, {
                    x: (this.head.aCoords.tr.x + this.head.aCoords.br.x) / 2,
                    y: (this.head.aCoords.tr.y + this.head.aCoords.br.y) / 2
                }, 25 * 10 * this.controlScale)
                this.flip.set({
                    left: flipPoint.x,
                    top: flipPoint.y
                })
                this.flip.setCoords();

                let deletePoint = this.getEndPointByTrigonometric(this.head.angle, {
                    x: (this.head.aCoords.tr.x + this.head.aCoords.br.x) / 2,
                    y: (this.head.aCoords.tr.y + this.head.aCoords.br.y) / 2
                }, 60 * 10 * this.controlScale)
                this.delete.set({
                    left: deletePoint.x,
                    top: deletePoint.y
                })
                this.delete.setCoords();

                this.canvas.renderAll();
            }
        }
    }

    mouseOver(o) {
        if (this.isDown) return;

        if (o.target.tag.includes(DEFINE.TAG.COMPASS_HEAD)) {
            this.rotator.set({
                visible: true,
                left: (this.head.aCoords.tl.x + this.head.aCoords.tr.x) / 2,
                top: (this.head.aCoords.tl.y + this.head.aCoords.tr.y) / 2,
                angle: this.head.angle
            });
        } else if (o.target.tag.includes(DEFINE.TAG.COMPASS_RIGHT)) {
            this.horizontal.set({
                visible: true,
                left: this.right.left,
                top: this.right.top,
                angle: this.right.angle + (25 * ((this.isFlip) ? -1 : 1))
            });
        }

        this.canvas.renderAll();
    }

    mouseOut(o) {
        if (this.isDown) return;

        if (o.target.tag.includes(DEFINE.TAG.COMPASS_HEAD)) {
            this.rotator.set("visible", false);
        } else if (o.target.tag.includes(DEFINE.TAG.COMPASS_RIGHT)) {
            this.horizontal.set("visible", false);
        }

        this.canvas.renderAll();
    }

    antiClockWise(center, pList) {
        let sum = 0;
        for (let i = 0; i < pList.length - 1; i++) {
            let p1 = pList[i];
            let p2 = pList[i + 1];
            sum += -0.5 * ((p2.y - center.y) + (p1.y - center.y)) * ((p2.x - center.x) - (p1.x - center.x));
        }
        return (sum > 0);
    }

    getEndPointByTrigonometric(angle, startPoint, distance) {
        let endPoint = { x: 0, y: 0 };

        //角度轉弧度
        let radian = (angle * Math.PI) / 180;

        //計算新座標 r 就是兩者的距離
        endPoint.x = startPoint.x + distance * Math.cos(radian);
        endPoint.y = startPoint.y + distance * Math.sin(radian);

        return endPoint;
    }

    scaling(originX, originY, originScale) {
        this.scale = this.baseScale / this.canvas.getZoom();
        this.controlScale = this.baseControlScale / this.canvas.getZoom();

        if (!this.show) return;

        if (this.left && this.right && this.head && this.center && this.horizontal && this.rotator && this.delete && this.flip) {
            let group = new fabric.Group([this.left, this.right, this.head, this.center, this.horizontal, this.rotator, this.delete, this.flip]);

            group.set({
                left: fabric.util.invertTransform(this.canvas.viewportTransform)[4] + ((group.left * originScale + originX) / this.canvas.getZoom()),
                top: fabric.util.invertTransform(this.canvas.viewportTransform)[5] + ((group.top * originScale + originY) / this.canvas.getZoom()),
                scaleX: this.scale / this.left.scaleX,
                scaleY: this.scale / this.left.scaleX
            })

            this.canvas.remove(this.left, this.right, this.head, this.center, this.horizontal, this.rotator, this.delete, this.flip);

            this.left = null;
            this.right = null;
            this.head = null;
            this.center = null;
            this.horizontal = null;
            this.rotator = null;
            this.delete = null;
            this.flip = null;

            group.forEachObject((i) => {
                group.removeWithUpdate(i);
                this.canvas.add(i);
                this.recover(i);
            });
        }
    }
}